$(document).ready(function () {
    $(window).on('scroll', function () {
      setTimeout(function() {
        if ($(this).scrollTop() > 100) {
            $('body.template-index').addClass('scrolledd');
        } else {
            $('body.template-index').removeClass('scrolledd');
        }
      }, 5000);  
    });
});


$(function(){
$('.cursive-animation').slick({
    draggable:false,
    pauseOnHover:false,
    pauseOnFocus:false,
    speed: 110000,
    autoplay: true,
    autoplaySpeed: 0,    
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,    
    infinite: true,    
    arrows: false,
    buttons: false
});
});


$(function(){
$('.animation-heading').slick({
    draggable:false,
    pauseOnHover:false,
    pauseOnFocus:false,
    speed: 100000,
    autoplay: true,
    autoplaySpeed: 0,    
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,    
    infinite: true,    
    arrows: false,
    buttons: false,
    variableWidth: true,    
   responsive: [     
      {
        breakpoint: 749,
        settings: {
         autoplaySpeed: 0, 
         speed: 20000,  
         infinite: true   
        }
      }
    ]
});
});

$(function(){
$('.insta-tiktok').slick({
    draggable:false,  
    pauseOnHover:false,
    pauseOnFocus:false,
    speed: 110000,
    autoplay: true,
    autoplaySpeed: 0,    
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,    
    infinite: true,    
    arrows: false,
    buttons: false,    
    responsive: [     
      {
        breakpoint: 749,
        settings: {
         autoplaySpeed: 0, 
         speed: 40000, 
         variableWidth: true,
         infinite: true   
        }
      }
    ]
});
});







////////////////// Start featured-collection-slider

if (screen.width < 750) {
   $(function(){
$('.featured-collection-slider-mob').slick({  
    draggable:false,     
    //speed: 8000,
    autoplay: true,
    autoplaySpeed: 4000,    
    //cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,   
    pauseOnHover:false, 
    infinite: false,    
    arrows: true,
    buttons: false,   
});
});
  
}
else {
 /*   
document.addEventListener("DOMContentLoaded", function () {
    const animation = { duration: 30000, easing: (t) => t };
    let currentSlide = 0;
    let loaded = false;
    let sliderPaused = false;

    const sliderElement = document.querySelector(".featured-collection-slider");

    if (!sliderElement) {
        console.error("Element '.featured-collection-slider' not found!");
        return;
    }

    const slider = new KeenSlider(sliderElement, {
        loop: true,
        breakpoints: {
            "(max-width: 899px)": {
                slides: { perView: "auto", spacing: 12 },
            },
            "(min-width: 900px)": {
                slides: { perView: "auto", spacing: 12 },
            },
        },
        slides: {
            renderMode: "performance",
            drag: true,
        },
        created(s) {
            if (s.track?.details) {
                s.moveToIdx(5, true, animation);
                loaded = true;
            }
        },
        updated(s) {
            if (s.track?.details && !sliderPaused) {
                s.moveToIdx(s.track.details.abs + 5, true, animation);
            }
        },
        animationEnded(s) {
            if (s.track?.details && !sliderPaused) {
                s.moveToIdx(s.track.details.abs + 5, true, animation);
            }
        },
        slideChanged(slider) {
            if (slider.track?.details) {
                currentSlide = slider.track.details.rel;
            }
        },
    });

    // Pause on hover
    sliderElement.addEventListener("mouseenter", () => {
        sliderPaused = true;
        slider.animator.stop(); // Stop animation
    });

    // Resume on mouse leave
    sliderElement.addEventListener("mouseleave", () => {
        sliderPaused = false;
        slider.moveToIdx(slider.track.details.abs + 5, true, animation); // Restart animation
    });
});
*/

}

////////////////// End featured-collection-slider




  

$(document).ready(function () {
    function checkVisibility() {
        var pageTop = $(document).scrollTop();
        var pageBottom = pageTop + $(window).height();

        var classes = [
            "fadeup",
            //"img-with-overlay-section-image",
            "new-class-1"
        ];

        // Select all elements with the specified classes
        var tags = $(classes.map(cls => `.${cls}`).join(", "));

        tags.each(function () {
            var $tag = $(this);
            if ($tag.offset().top < pageBottom) {
                $tag.addClass("visible");
            } else {
                $tag.removeClass("visible");
            }
        });
    }

    // Run the function on load and scroll
    $(document).on("scroll", checkVisibility);
    checkVisibility(); // Run on page load
});


window.addEventListener('scroll', () => {
  const parallaxContainers = document.querySelectorAll('.img-with-overlay-section-image');
  const windowHeight = window.innerHeight;

  parallaxContainers.forEach(container => {
    const containerRect = container.getBoundingClientRect();

    // Check if the container is in the viewport
    if (containerRect.top <= windowHeight && containerRect.bottom >= 0) {
      // Calculate the scroll position relative to the container
      const scrollPosition = Math.min(
        Math.max(0, windowHeight - containerRect.top),
        containerRect.height
      );

      // Adjust this multiplier for the parallax intensity
      const parallaxSpeed = 0.15;

      // Move the background position
      container.style.backgroundPosition = `center ${-scrollPosition * parallaxSpeed}px`;
    } else {
      // Optional: Reset or adjust background position if not in viewport
      // container.style.backgroundPosition = `center -50px`;
    }
  });
});


window.addEventListener('scroll', () => {
  const parallaxContainer = document.querySelector('.multiple-image-main');

  if (parallaxContainer) {
    const containerRect = parallaxContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Check if the container is in the viewport
    if (containerRect.top <= windowHeight && containerRect.bottom >= 0) {
      // Calculate the scroll position relative to the container
      const scrollPosition = Math.min(
        Math.max(0, windowHeight - containerRect.top),
        containerRect.height
      );

      // Adjust this multiplier for the parallax intensity
      const parallaxSpeed = 0.10;

      // Move the background position
      parallaxContainer.style.backgroundPosition = `center ${-scrollPosition * parallaxSpeed}px`;
    } else {
      //parallaxContainer.style.backgroundPosition = `center -50px`;
    }
  }
});

window.addEventListener('scroll', () => {
  const parallaxContainer = document.querySelector('.multiple-image-main');
  const parallaxElements = document.querySelectorAll('.plax-top'); // Select all elements

  if (parallaxContainer && parallaxElements.length > 0) {
    const containerRect = parallaxContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Check if the container is in the viewport
    if (containerRect.top <= windowHeight && containerRect.bottom >= 0) {
      // Calculate the scroll position relative to the container
      const scrollPosition = Math.min(
        Math.max(0, windowHeight - containerRect.top),
        containerRect.height
      );

      // Adjust this multiplier for the parallax intensity
      const parallaxSpeed = 0.05;

      // Apply transform to each .plax-top element
      parallaxElements.forEach((element) => {
        element.style.transform = `translateY(${-scrollPosition * parallaxSpeed}px)`;
      });
    }
  }
});



/*
document.addEventListener('DOMContentLoaded', () => {
  // Find all product cards on the collection page
  const productCards = document.querySelectorAll('.product-card-wrapper');

  productCards.forEach((card) => {
    const image = card.querySelector('.card_product_main_img');
    const link = card.querySelector('.product_url_card');
    const colorButtons = card.querySelectorAll('.card_color_swatch');

    colorButtons.forEach((button) => {
      button.addEventListener('click', () => {
        // Get the new image and URL from the button's dataset
        const newImage = button.dataset.image;
        const newUrl = button.dataset.url;

        // Update the product image and link dynamically
        image.srcset = newImage;
        image.src = newImage;
        link.href = newUrl;

        // Optionally, update the active color state
        colorButtons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');
      });
    });
  });
});
*/

window.addEventListener('scroll', () => {
  const parallaxContainer = document.querySelector('.main-product-template-section');
  if (parallaxContainer) {
    const containerRect = parallaxContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    // Check if the container is in the viewport
    if (containerRect.top <= windowHeight && containerRect.bottom >= 0) {
     $('body.template-product .header-wrapper').addClass('hide-main-header');
    } else {
       $('body.template-product .header-wrapper').removeClass('hide-main-header');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {  
    document.addEventListener("click", function (event) {
        const clickedElement = event.target.closest(".product-variant-swatch-button");

        // If clicked outside the swatch button, remove 'active' class from all divs
        if (!clickedElement) {
            document.querySelectorAll(".product-variant-swatch-options.active")
                .forEach(div => div.classList.remove("active"));
            return;
        }

        const nextDiv = clickedElement.nextElementSibling;

        // Check if the next sibling div is a '.product-variant-swatch-options'
        if (nextDiv && nextDiv.classList.contains("product-variant-swatch-options")) {
            // If the next div already has 'active', remove the class (toggle effect)
            if (nextDiv.classList.contains("active")) {
                nextDiv.classList.remove("active");
            } else {
                // Otherwise, remove 'active' class from all other divs and add it to the clicked one
                document.querySelectorAll(".product-variant-swatch-options.active")
                    .forEach(div => div.classList.remove("active"));
                nextDiv.classList.add("active");
            }
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
$('.accordian-title').click(function(e) {
  	e.preventDefault();  
    let $this = $(this);  
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
        $(this).removeClass('active');
    } else {
        $this.parent().parent().find('.accordion-common .accordion__content').removeClass('show');
        $this.parent().parent().find('.accordion-common .accordion__content').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
      
        $this.parent().parent().find('.accordion-common .accordian-title').removeClass('active');
        $(this).toggleClass('active');
    }
}); 
});


window.addEventListener('scroll', () => {
  const parallaxContainer = document.querySelector('body.template-lookbook');
  const parallaxElements = document.querySelectorAll('.lookbook-title h2');

  if (!parallaxContainer || parallaxElements.length === 0) return;

  const containerRect = parallaxContainer.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  requestAnimationFrame(() => {
    parallaxElements.forEach(element => {
      if (containerRect.top <= windowHeight && containerRect.bottom >= 0) {
        const scrollPosition = Math.min(
          Math.max(0, windowHeight - containerRect.top),
          containerRect.height
        );

        const parallaxSpeed = 0.6;
        let translateValue = -scrollPosition * parallaxSpeed;

        if (containerRect.top >= 0) translateValue = 0; // Ensure 0px at the top

        element.style.transform = `translateX(${translateValue}px)`;
      } else {
        element.style.transform = `translateX(0px)`;
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash;

    if (urlParams.get("customer_posted") === "true" && hash === "#MultipleNewsletter") {
        document.body.classList.add("newsletter-subscribed");
         $(".multiple-image-block-newsletter").css("opacity", 0).show().animate({ opacity: 1 }, 1500);
    }
});

$(document).ready(function () {
    $(".shownewsletter").click(function (event) {
        //$(".multiple-image-block-newsletter").show(); 
        $(".multiple-image-block-newsletter").css("opacity", 0).show().animate({ opacity: 1 }, 1500);
        $(".mt-text-box-button").hide();        
    });    
});

document.addEventListener("DOMContentLoaded", function () {
    const imageContainers = document.querySelectorAll(".lookbook-product-row a");

    imageContainers.forEach(container => {
        const hint = container.querySelector(".lookbook-product-details");

        container.addEventListener("mousemove", (e) => {
            const rect = container.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            hint.style.opacity = "1";
            hint.style.left = `${x}px`;
            hint.style.top = `${y}px`;
        });

        container.addEventListener("mouseleave", () => {
            hint.style.opacity = "0";
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const backToTopButton = document.getElementById("back-to-top");

    if (backToTopButton && backToTopButton.dataset.enabled === "true") {
        backToTopButton.style.display = "block"; // Show button if enabled

        backToTopButton.addEventListener("click", function () {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    }
});

